module.exports = __webpack_public_path__ + "static/img/8.87c1386.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/8.png
// module id = OYHu
// module chunks = 0